var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.861,
    height: 21.861,
    viewBox: "0 0 21.861 21.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-insert-template",
    "data-name": "Icon metro-insert-template",
    d: "M10.394,5.839H13v1.3H10.394Zm3.911,0h2.608v1.3H14.305Zm4.519,0v5.215H16.913v-1.3h.608V7.143h.7v-1.3ZM9.09,9.751H11.7v1.3H9.09Zm3.911,0h2.608v1.3H13ZM8.482,7.143V9.751h-.7v1.3H7.178V5.839H9.09v1.3Zm1.911,6.519H13v1.3H10.394Zm3.911,0h2.608v1.3H14.305Zm4.519,0v5.215H16.913v-1.3h.608V14.966h.7v-1.3ZM9.09,17.574H11.7v1.3H9.09Zm3.911,0h2.608v1.3H13ZM8.482,14.966v2.608h-.7v1.3H7.178V13.662H9.09v1.3ZM22.128,3.232H3.875V21.485H22.128V3.232Zm1.3-1.3V22.789H2.571V1.928H23.432Z",
    transform: "translate(-2.071 -1.428)",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/TemplateIcon.fdf15fe7f0e0c363515b606ed86bdeea.svg";
export { ForwardRef as ReactComponent };